import { render, staticRenderFns } from "./KanbanDashboard.vue?vue&type=template&id=1576a2a3&scoped=true&"
import script from "./KanbanDashboard.vue?vue&type=script&lang=js&"
export * from "./KanbanDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KanbanDashboard.vue?vue&type=style&index=0&id=1576a2a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1576a2a3",
  null
  
)

export default component.exports